export type DataLayerPayload = { event: string } & Record<string, unknown>

export function pushDataLayerEvent(payload: DataLayerPayload): void {
    if (!import.meta.client) return

    const globalWindow = window as Window & { dataLayer?: DataLayerPayload[] }
    globalWindow.dataLayer = globalWindow.dataLayer || []
    globalWindow.dataLayer.push(payload)
}
